export default request => {
  const { status, statusText, responseURL, responseText } = request;
  return {
    statusText,
    statusCode: status,
    url: responseURL,
    responseText
  };
};
